import { useToast } from "../../utils/toast";
import { ForumTopicEnum } from "../../services/forum/forum.dto";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { MenuItem } from "primereact/menuitem";

export interface CardDataDto {
  imgSrc: string;
  title: string;
  description: string;
  value: ForumTopicEnum;
}

export const cardData: CardDataDto[] = [
  {
    imgSrc: "/images/landing-page/hesaplama.jpg",
    title: "Son Açılan Konular",
    description: "Kullanıcılar tarafından en son oluşturulan konuları görüntüleyebilirsiniz.",
    value: ForumTopicEnum.GENEL
  },
  {
    imgSrc: "/images/forum/yesil-donusum.jpg",
    title: "Yeşil Dönüşüm",
    description: "Sürdürülebilirlik, çevresel performans, iyileştirme ve malzeme-kaynak yönetimi raporları.",
    value: ForumTopicEnum.YESIL_DONUSUM
  },
  {
    imgSrc: "/images/forum/dijital-donusum.jpg",
    title: "Dijital Dönüşüm",
    description:
      "Yeşil dönüşüm olgunluk analizi, dijital dönüşüm endeksi ve sektör/bölge/ülke genelindeki istatistikler ve raporlar.",
    value: ForumTopicEnum.DIJITAL_DONUSUM
  },
  {
    imgSrc: "/images/landing-page/egitim.jpg",
    title: "Eğitim",
    description: "Sürdürülebim değişikliğine uyum eğitimleri.",
    value: ForumTopicEnum.EGITIM
  },
  {
    imgSrc: "/images/landing-page/afad.jpg",
    title: "İş Sürekliliği",
    description:
      "Afet durumunda sanayi kuruluşlarının kesintisiz faaliyet göstermesi için AFAD ve Sanayi Bakanlığı ile geliştirdiğimiz işbirliği çalışmaları.",
    value: ForumTopicEnum.IS_GELISTIRME
  },
  {
    imgSrc: "/images/forum/arge.jpg",
    title: "ARGE",
    description: "Türkiye genelindeki organijeler ve sektörel gelişmeler.",
    value: ForumTopicEnum.ARGE
  },
  {
    imgSrc: "/images/forum/kapasite-gelistirme.jpg",
    title: "Kapasite Geliştirme",
    description: "Sanayi kuruluşlarının üretim kapasitelerini artırmaya yönelik stratejik işbirliği çalışmaları.",
    value: ForumTopicEnum.KAPASITE_GELISTIRME
  },
  {
    imgSrc: "/images/forum/is-surekliligi.jpg",
    title: "İş Geliştirme",
    description:
      "Türkiye genelindeki organize sanayi bölgelerinin iş sürekliliği planları ve sektörel gelişmelere dair bilgiler.",
    value: ForumTopicEnum.IS_SUREKLILIGI
  }
];

const ForumHomePage = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  //const [selectedCard, setSelectedCard] = useState<CardDataDto>(cardData[0]);
  //const [forums, setForums] = useState<ForumWithoutMessage[]>([]);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const items: MenuItem[] = [{ label: "Forum" }];
  const home: MenuItem = {
    icon: "pi pi-home",
    command: () => {
      navigate("/app/forum-homepage");
    }
  };

  const changeTopic = (card: CardDataDto) => {
    if (card.value != null) {
      const topicId = card.value.toString();
      navigate(`/app/forum-page/${topicId}`);
    }
  };

  function handleSearch(searchTerm: string): void {
    navigate(`/app/forum-page/${"1"}`, { state: { searchTerm } });
  }

  return (
    <div className="card p-2 sm:p-4">
      <BreadCrumb className="mb-3 border-none p-0 bg-transparent" model={items} home={home} />

      <div className="flex flex-column sm:flex-row justify-content-between gap-3 mb-4">
        <div className="p-inputgroup flex-1">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Konuları ara..."
            className="p-inputtext p-component w-full"
            onKeyDown={(e) => e.key === "Enter" && handleSearch(searchTerm)}
          />
          <Button
            label="Ara"
            icon="pi pi-search"
            className="p-button-outlined"
            onClick={() => handleSearch(searchTerm)}
          />
        </div>
        <Button
          label="Yeni Konu Aç"
          icon="pi pi-plus"
          className="w-full sm:w-auto"
          onClick={() => navigate("/app/forum-ekle")}
        />
      </div>

      <div id="features" className="w-full">
        <div className="grid">
          {cardData.map((card, index) => (
            <div className="col-12 sm:col-6 lg:col-3" key={index}>
              <div
                className="surface-card border-1 surface-border border-round-xl p-3 h-full hover:shadow-2 transition-duration-200 cursor-pointer flex align-items-center gap-3"
                onClick={() => changeTopic(card)}
              >
                <img
                  src={card.imgSrc}
                  alt={card.title}
                  className="shadow-1 border-round flex-shrink-0"
                  style={{ width: "3.75rem", height: "3.75rem", objectFit: "cover" }}
                />
                <div className="flex flex-column justify-content-center overflow-hidden">
                  <h5 className="m-0 text-900 text-base font-semibold line-clamp-2">{card.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ForumHomePage;
